/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
});

jQuery(document).ready(function() {

	var $ = jQuery;

	function navOffset() {
		var navHeight = $('.top-bar').outerHeight();
		$('.top-bar-offset').css('height', navHeight);
		// console.log(navHeight, 'resize');
	}
	navOffset();

	function setNavSize() {
		var navOffset = $('.top-bar-offset').offset().top - $(window).scrollTop();
		if(navOffset < 0) {
			$('.top-bar').addClass('shrink');
		} else {
			$('.top-bar').removeClass('shrink');
			setTimeout(function(){
				var navHeight = $('.top-bar').outerHeight();
				$('.top-bar-offset').css('height', navHeight);
				// console.log("Hello");
			}, 250);

		}
	}

	$(window).on('scroll resize', function() {
		navOffset();
		setNavSize();
	});
});
